import * as React from 'react';
import { FC } from 'react';
import { Box } from '@mui/material';
import { FormatCurrency, FormatCurrencyType, MutedText } from 'shared/components/Format/Currency';
import { UserBalanceDto } from 'app/interfaces/dto';
import { MISSING_ACCOUNT_PLACEHOLDER } from 'modules/payments/constants';

interface UserBalanceLineParametersProps {
  account: Pick<UserBalanceDto, 'currency' | 'balance'>;
  fiatEquivalent: number;
  size: 'small' | 'medium';
}

export const UserBalanceLine: FC<UserBalanceLineParametersProps> = ({
  account,
  fiatEquivalent,
  size,
}) => {
  return (
    <Box display="flex">
      {account ? (
        <>
          <FormatCurrency
            currency={account.currency}
            amount={account.balance}
            type={FormatCurrencyType.Crypto}
          />
          {size === 'medium' ? (
            <>
              <MutedText>&nbsp;≈&nbsp;</MutedText>
              <FormatCurrency
                amount={fiatEquivalent}
                type={FormatCurrencyType.Fiat}
                currency="USD"
              />
            </>
          ) : null}
        </>
      ) : (
        MISSING_ACCOUNT_PLACEHOLDER
      )}
    </Box>
  );
};
